import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; 
import config from '../../config';

function CategoryList() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/categories/`, { withCredentials: true });
            
            if(response.data.success && response.data.data){
                setCategories(response.data.data);
            }

        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const filteredCategories = categories.filter(category =>
        category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (category.description && category.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Categories</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total 
                                        <div className="count"> {filteredCategories.length} Categories</div>
                                    </div>
                                    <div className="project_search">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <input 
                                                type="text" 
                                                name="search" 
                                                placeholder="Search Categories" 
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <button type="submit" className="btn">Search</button>
                                        </form>
                                    </div>
                                    <div className="add_project">
                                        <Link to="/admin/category-add">Add Category</Link>
                                    </div>
                                </header>
                                <table className="projects-table">
                                    <thead>
                                        <tr>
                                            <th>Category Name</th>
                                            <th>Description</th>
                                            <th>Created At</th>
                                            <th className="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : filteredCategories.length === 0 ? (
                                            <tr>
                                                <td colSpan="4">No categories found</td>
                                            </tr>
                                        ) : (
                                            filteredCategories.map((category, index) => ( 
                                                <tr key={category._id}>
                                                    <td><p>{category.name}</p></td>
                                                    <td><p>{category.description || 'No description'}</p></td>
                                                    <td><p>{new Date(category.createdAt).toLocaleDateString()}</p></td>
                                                    <td>
                                                        <Link to={`/admin/category-details/${category._id}`} className="view_detail">View Details</Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CategoryList;
